import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { ApiRequestService, DateUtilPipe, ListViewComponent, TranslationPipe } from '@prekog/common-ui';
import { Festival } from '../shared/festival';
import { GetFestivalsResponse } from '../shared/getfestivalsresponse';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'app-festivals',
    templateUrl: './festivals.component.html',
    styleUrls: ['./festivals.component.scss'],
    standalone: true,
    imports: [ReactiveFormsModule, DateUtilPipe, ListViewComponent, MatIconModule, ListViewComponent, TranslationPipe]
})
export class FestivalsComponent implements OnInit {
    addFestivalURI = '/addfestival';
    festivals: Festival[] = [];
    getFestivalsURI = '/admin/getFestivals';

    storeBaseUrl = inject<string>('STORE_BACKEND_URL' as never);

    private _router = inject(Router);
    private _apiRequestService = inject(ApiRequestService);

    ngOnInit(): void {
        this._loadFestivals();
    }

    onSelectFestival(festival: Festival): void {
        localStorage.setItem('festival', JSON.stringify(festival));
        void this._router.navigate([this.addFestivalURI], {
            queryParams: {
                mode: 'edit'
            }
        });
    }

    private _loadFestivals(): void {
        this._apiRequestService.sendRequest(this.storeBaseUrl, {}, true, this.getFestivalsURI).subscribe((response) => {
            const getFestivals = response as GetFestivalsResponse;
            this.festivals = getFestivals.festivalList as Festival[];
        });
    }
}
